import Icon from '@mdi/react';
import { mdiCheckCircleOutline, mdiAlertCircleOutline, mdiClose } from '@mdi/js';
import { EmploymentUpdateStatus } from '@my-pages/features/employment/types';

interface IEmploymentUpdatedBanner {
    status: EmploymentUpdateStatus;
    closeDisplayMessage: () => void;
}

const EmploymentUpdatedBanner = ({ status, closeDisplayMessage }: IEmploymentUpdatedBanner) => {
    const isSuccess = status === EmploymentUpdateStatus.Success;
    const alertClass = isSuccess ? 'alert-success' : 'alert-danger';
    const icon = isSuccess ? mdiCheckCircleOutline : mdiAlertCircleOutline;
    const message = isSuccess 
        ? 'Tack, ditt ärende har registrerats hos handläggare som ändrar uppgifterna manuellt.'
        : 'Ett fel uppstod vid uppdatering av uppgifterna. Vänligen försök igen.';

    return (
        <div className={`alert ${alertClass} d-flex align-items-center`} role="alert">
            <Icon path={icon} className="mdi mr-2"/>
            <p className="alert-heading mb-0 flex-grow-1">
                {message}
            </p>
            <button 
                type="button" 
                className="btn btn-link p-0 ml-2"
                onClick={closeDisplayMessage}
                aria-label="Close"
            >
                <Icon path={mdiClose} className="mdi mdi-24"/>
            </button>
        </div>
    );
};

export default EmploymentUpdatedBanner;
